import { incNextId } from '../redux/slices/resourceMeta'
import { AppDispatch, RootState } from '../redux/store'

export const getNextId = (dispatch: AppDispatch, getState: () => RootState) => {
    const id = getState().resourceMeta.nextId
    dispatch(incNextId())
    return id
}